module.exports = __webpack_public_path__ + "img/globo.50a53d96.png";